import React from 'react';
import ErrorContainer from './containers';
import { useTranslation } from 'react-i18next';

const InternalServerError = () => {
  const { t } = useTranslation();
  return <ErrorContainer message={t('errors.internalServerError')} />;
};

export default InternalServerError;
